import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';

import * as S from './InsightsLoadingCard.styles';

export const InsightsLoadingCard = () => {
  return (
    <S.LoadingWrapper>
      <SkeletonLoader
        data-testid="insights-group-loading"
        areas={[
          {
            styles: {
              width: '100%',
              height: 60,
            },
          },
        ]}
      />
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '100%',
              height: 60,
            },
          },
        ]}
      />
    </S.LoadingWrapper>
  );
};
